import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';
import { AuthGuard } from './utils/guards/auth.guard';
import { GuestGuard } from './utils/guards/guest.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full',
  },
  {
    path: 'home',
    redirectTo: 'tabs/tabHome',
    pathMatch: 'full',
  },
  {
    path: 'wishlist',
    redirectTo: 'tabs/tabWishlist',
    pathMatch: 'full',
  },
  {
    path: 'transaksi',
    redirectTo: 'tabs/tabTransaction',
    pathMatch: 'full',
  },
  {
    path: 'profile',
    redirectTo: 'tabProfile',
    pathMatch: 'full',
  },
  {
    path: 'data-instansi',
    redirectTo: 'invoice',
    pathMatch: 'full',
  },
  {
    path: 'notifikasi',
    redirectTo: 'notification',
    pathMatch: 'full',
  },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomePageModule),
    canLoad: [GuestGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule),
    canLoad: [GuestGuard],
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule),
    canLoad: [GuestGuard],
  },
  {
    path: 'tabs',
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule),
  },
  {
    path: 'detail',
    loadChildren: () => import('./pages/detail-book/detail-book.module').then(m => m.DetailBookPageModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'edited',
    loadChildren: () =>
      import('./pages/tabProfile/edit-profile/edit-profile.module').then(m => m.EditProfilePageModule),
  },
  {
    path: 'payment',
    loadChildren: () => import('./pages/tabProfile/payment/payment.module').then(m => m.PaymentPageModule),
  },
  {
    path: 'not-found',
    loadChildren: () => import('./pages/not-found/not-found.module').then(m => m.NotFoundPageModule),
  },
  {
    path: 'server-error',
    loadChildren: () => import('./pages/server-error/server-error.module').then(m => m.ServerErrorPageModule),
  },
  {
    path: 'detail-book',
    loadChildren: () => import('./pages/detail-book/detail-book.module').then(m => m.DetailBookPageModule),
  },
  {
    path: 'product-detail/:productId',
    loadChildren: () => import('./pages/product-detail/product-detail.module').then(m => m.ProductDetailPageModule),
  },
  {
    path: 'cart',
    loadChildren: () => import('./pages/cart/cart.module').then(m => m.CartPageModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'list-alamat',
    loadChildren: () => import('./pages/list-alamat/list-alamat.module').then(m => m.ListAlamatPageModule),
  },
  {
    path: 'pilih-pembayaran',
    loadChildren: () =>
      import('./pages/pilih-pembayaran/pilih-pembayaran.module').then(m => m.PilihPembayaranPageModule),
  },
  {
    path: 'selesai-payment',
    loadChildren: () => import('./pages/selesai-payment/selesai-payment.module').then(m => m.SelesaiPaymentPageModule),
  },
  {
    path: 'detail-transaksi/:transactionId',
    loadChildren: () =>
      import('./pages/detail-transaksi/detail-transaksi.module').then(m => m.DetailTransaksiPageModule),
  },
  {
    path: 'detail-transaksi-refresh/:transactionId',
    loadChildren: () =>
      import('./pages/detail-transaksi/detail-transaksi.module').then(m => m.DetailTransaksiPageModule),
  },
  {
    path: 'edit-phonenumber',
    loadChildren: () =>
      import('./pages/tabProfile/edit-phonenumber/edit-phonenumber.module').then(m => m.EditPhonenumberPageModule),
  },
  {
    path: 'edit-password',
    loadChildren: () =>
      import('./pages/tabProfile/edit-password/edit-password.module').then(m => m.EditPasswordPageModule),
  },
  {
    path: 'add-address',
    loadChildren: () => import('./pages/tabProfile/add-address/add-address.module').then(m => m.AddAddressPageModule),
  },
  {
    path: 'add-customer-bank',
    loadChildren: () =>
      import('./pages/tabProfile/add-customer-bank/add-customer-bank.module').then(m => m.AddCustomerBankPageModule),
  },
  {
    path: 'detail-event/:eventId',
    loadChildren: () => import('./pages/detail-event/detail-event.module').then(m => m.DetailEventPageModule),
  },
  {
    path: 'tab-event',
    loadChildren: () => import('./pages/tabEvent/tabEvent.module').then(m => m.TabEventPageModule),
  },
  {
    path: 'tab-transaction',
    loadChildren: () => import('./pages/tabTransaction/tabTransaction.module').then(m => m.TabTransactionPageModule),
  },
  {
    path: 'voucher-list',
    loadChildren: () => import('./pages/voucher-list/voucher-list.module').then(m => m.VoucherListPageModule),
  },
  {
    path: 'voucher-detail/:voucherId/:type',
    loadChildren: () => import('./pages/voucher-detail/voucher-detail.module').then(m => m.VoucherDetailPageModule),
  },
  {
    path: 'tab-voucher',
    loadChildren: () => import('./pages/tab-voucher/tab-voucher.module').then(m => m.TabVoucherPageModule),
  },
  {
    path: 'my-voucher',
    loadChildren: () => import('./pages/tabProfile/my-voucher/my-voucher.module').then(m => m.MyVoucherPageModule),
  },
  {
    path: 'otp-input',
    loadChildren: () => import('./pages/otp-input/otp-input.module').then(m => m.OtpInputPageModule),
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./pages/reset-password/reset-password.module').then(m => m.ResetPasswordPageModule),
  },
  {
    path: 'history-point',
    loadChildren: () =>
      import('./pages/tabProfile/history-point/history-point.module').then(m => m.HistoryPointPageModule),
  },
  {
    path: 'verify',
    loadChildren: () => import('./pages/verify/verify.module').then(m => m.VerifyPageModule),
    canLoad: [GuestGuard],
  },
  {
    path: 'tier',
    loadChildren: () => import('./pages/tabProfile/tier/tier.module').then(m => m.TierPageModule),
  },
  {
    path: 'blog',
    loadChildren: () => import('./pages/blog/blog.module').then(m => m.BlogPageModule),
  },
  {
    path: 'layanan-kebijakan',
    loadChildren: () =>
      import('./pages/tabProfile/layanan-kebijakan/layanan-kebijakan.module').then(m => m.LayananKebijakanPageModule),
  },
  {
    path: 'layanan/registrasi',
    loadChildren: () =>
      import('./pages/tabProfile/layanan-kebijakan/layanan/registrasi/registrasi.module').then(
        m => m.RegistrasiPageModule,
      ),
  },
  {
    path: 'layanan/pemesanan',
    loadChildren: () =>
      import('./pages/tabProfile/layanan-kebijakan/layanan/pemesanan/pemesanan.module').then(
        m => m.PemesananPageModule,
      ),
  },
  {
    path: 'layanan/pembayaran',
    loadChildren: () =>
      import('./pages/tabProfile/layanan-kebijakan/layanan/pembayaran/pembayaran.module').then(
        m => m.PembayaranPageModule,
      ),
  },
  {
    path: 'layanan/pengiriman',
    loadChildren: () =>
      import('./pages/tabProfile/layanan-kebijakan/layanan/pengiriman/pengiriman.module').then(
        m => m.PengirimanPageModule,
      ),
  },
  {
    path: 'layanan/faq',
    loadChildren: () =>
      import('./pages/tabProfile/layanan-kebijakan/layanan/faq/faq.module').then(m => m.FaqPageModule),
  },
  {
    path: 'kebijakan/pengiriman',
    loadChildren: () =>
      import('./pages/tabProfile/layanan-kebijakan/kebijakan/pengiriman/pengiriman.module').then(
        m => m.PengirimanPageModule,
      ),
  },
  {
    path: 'kebijakan/pengembalian-barang',
    loadChildren: () =>
      import('./pages/tabProfile/layanan-kebijakan/kebijakan/pengembalian-barang/pengembalian-barang.module').then(
        m => m.PengembalianBarangPageModule,
      ),
  },
  {
    path: 'kebijakan/pengembalian-uang',
    loadChildren: () =>
      import('./pages/tabProfile/layanan-kebijakan/kebijakan/pengembalian-uang/pengembalian-uang.module').then(
        m => m.PengembalianUangPageModule,
      ),
  },
  {
    path: 'variable-detail/:code',
    loadChildren: () => import('./pages/variable-detail/variable-detail.module').then(m => m.VariableDetailPageModule),
  },
  {
    path: 'subcategories',
    loadChildren: () => import('./pages/subcategories/subcategories.module').then(m => m.SubcategoriesPageModule),
  },
  {
    path: 'tabProfile',
    loadChildren: () => import('./pages/tabProfile/tabProfile.module').then(m => m.TabProfilePageModule),
  },
  {
    path: 'promosi',
    loadChildren: () => import('./pages/promosi/promosi.module').then(m => m.PromosiPageModule),
  },
  {
    path: 'rekomendasi',
    loadChildren: () => import('./pages/rekomendasi/rekomendasi.module').then(m => m.RekomendasiPageModule),
  },
  {
    path: 'category-detail/:categoryId',
    loadChildren: () => import('./pages/category-detail/category-detail.module').then(m => m.CategoryDetailPageModule),
  },
  {
    path: 'subcategory-detail/:subcategoryId',
    loadChildren: () =>
      import('./pages/subcategory-detail/subcategory-detail.module').then(m => m.SubcategoryDetailPageModule),
  },
  {
    path: 'offers',
    loadChildren: () => import('./pages/offers/offers.module').then(m => m.OffersPageModule),
  },
  {
    path: 'search-products',
    loadChildren: () => import('./pages/search-products/search-products.module').then(m => m.SearchProductsPageModule),
  },
  {
    path: 'categories',
    loadChildren: () => import('./pages/categories/categories.module').then(m => m.CategoriesPageModule),
  },
  {
    path: 'edit-address',
    loadChildren: () =>
      import('./pages/tabProfile/edit-address/edit-address.module').then(m => m.EditAddressPageModule),
  },
  {
    path: 'checkout',
    loadChildren: () => import('./pages/checkout/checkout.module').then(m => m.CheckoutPageModule),
  },
  {
    path: 'kelengkapan-data',
    loadChildren: () =>
      import('./pages/kelengkapan-data/kelengkapan-data.module').then(m => m.KelengkapanDataPageModule),
  },
  {
    path: 'pemesanan',
    loadChildren: () => import('./pages/pemesanan/pemesanan.module').then(m => m.PemesananPageModule),
  },
  {
    path: 'pilih-pengiriman',
    loadChildren: () =>
      import('./pages/pilih-pengiriman/pilih-pengiriman.module').then(m => m.PilihPengirimanPageModule),
  },
  {
    path: 'konsultasi-ekspedisi',
    loadChildren: () =>
      import('./pages/konsultasi-ekspedisi/konsultasi-ekspedisi.module').then(m => m.KonsultasiEkspedisiPageModule),
  },
  {
    path: 'waktu-pengambilan',
    loadChildren: () =>
      import('./pages/waktu-pengambilan/waktu-pengambilan.module').then(m => m.WaktuPengambilanPageModule),
  },
  {
    path: 'ringkasan',
    loadChildren: () => import('./pages/ringkasan/ringkasan.module').then(m => m.RingkasanPageModule),
  },
  {
    path: 'pembayaran',
    loadChildren: () => import('./pages/pembayaran/pembayaran.module').then(m => m.PembayaranPageModule),
  },
  {
    path: 'transaksi-berhasil',
    loadChildren: () =>
      import('./pages/transaksi-berhasil/transaksi-berhasil.module').then(m => m.TransaksiBerhasilPageModule),
  },
  {
    path: 'order-detail/:orderId',
    loadChildren: () => import('./pages/order-detail/order-detail.module').then(m => m.OrderDetailPageModule),
  },
  {
    path: 'setting',
    loadChildren: () => import('./pages/setting/setting.module').then(m => m.SettingPageModule),
  },
  {
    path: 'brands',
    loadChildren: () => import('./pages/brands/brands.module').then(m => m.BrandsPageModule),
  },
  {
    path: 'membership',
    loadChildren: () => import('./pages/membership/membership.module').then(m => m.MembershipPageModule),
  },
  {
    path: 'invoice',
    loadChildren: () => import('./pages/invoice/invoice.module').then(m => m.InvoicePageModule),
  },
  {
    path: 'product-rating',
    loadChildren: () => import('./pages/product-rating/product-rating.module').then(m => m.ProductRatingPageModule),
  },
  {
    path: 'upload-payment-proof',
    loadChildren: () =>
      import('./pages/upload-payment-proof/upload-payment-proof.module').then(m => m.UploadPaymentProofPageModule),
  },
  {
    path: 'faktur-pajak',
    loadChildren: () => import('./pages/faktur-pajak/faktur-pajak.module').then(m => m.FakturPajakPageModule),
  },
  {
    path: 'product-reviews/:productId',
    loadChildren: () => import('./pages/product-reviews/product-reviews.module').then(m => m.ProductReviewsPageModule),
  },
  {
    path: 'notification',
    loadChildren: () => import('./pages/notification/notification.module').then(m => m.NotificationPageModule),
  },
  {
    // path: 'chatroom/:id',
    path: 'chatroom',
    loadChildren: () => import('./pages/chatroom/chatroom.module').then(m => m.ChatroomPageModule),
  },
  {
    path: '**',
    redirectTo: '/not-found',
    pathMatch: 'full',
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: QuicklinkStrategy,
      relativeLinkResolution: 'corrected',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
